import { Grid } from "@mui/material";
import ChatProvider from "../context/ChatContext";
import ChatWindow from "./ChatWindow";
import SideBar from "./SideBar";
import { SignedIn } from "@clerk/clerk-react";

const Internal = () => {
	return (
		<SignedIn>
			<Grid container spacing={0}>
				{/* Make the sidebar take full width on xs screens and 3/12 on sm screens and above */}
				<Grid item xs={12} sm={3}>
					<SideBar />
				</Grid>
				{/* Make the chat window take full width on xs screens and 9/12 on sm screens and above */}
				<Grid item xs={12} sm={9}>
					<ChatProvider>
						<ChatWindow />
					</ChatProvider>
				</Grid>
			</Grid>
		</SignedIn>
	);
};

export default Internal;
